<template>
    <div>
        <button 
          type="button"
          class="btn p-0 btn-link"
          :id="id"
          @click="action"
        >
            <img src='@/assets/icons/plus1.svg' style="margin-left: 2px; margin-bottom: 3px"/>
            <span v-if="withText" class="f-16 f-semi f-c-blue p-l-8">{{ text }}</span>
        </button>
    </div>
</template>

<script>
export default {
	name: "SOButtonPlusLink",
	props: {
    withText: {
        type: Boolean,
        default: true
    },
		text: {
        type: String,
    },
		id: {
        type: String,
        required: true
    },
	},
	methods: {
		action(payload) {
			this.$emit("action", payload)
		}
	},
}
</script>